<!-- Slide out notifications for top nav -->
<ea-slider
	[direction]="SliderDirection.Right"
	[duration]="constants.NOTIFICATIONS.SLIDER_DURATION"
	[widthPercent]="40"
	[sliderId]="constants.sliderIds.NOTIFICATION">
	<ng-template #slidingPanel>
		@if (!isNotificationSliderOpenRead) {
			<!-- We need below div element to get the focus of screen reader on top of the dialog/slider-->
			<button
				aria-label="Notifications Slider"
				id="notificationHeader"
				type="button"
				class="sr-only"
				(keydown)="handleKeyDown()"></button>
		}
		<div class="d-flex row notification-header">
			<div class="d-flex col-1 justify-content-start">
				<button
					(click)="closeSlider()"
					type="button"
					class="close-button-wrapper"
					aria-label="Close notification"
					(keydown)="handleKeyDown()">
					<span aria-hidden="true">
						<ea-icon [hasMargin]="false" name="close"></ea-icon>
					</span>
				</button>
			</div>
			<div class="col d-flex justify-content-center align-items-center">
				<ea-heading
					[type]="HEADING_TYPES.h4"
					[size]="HEADING_SIZES.sm"
					data-cy="notifications-sliding-panel-header"
					[attr.aria-label]="constants.NOTIFICATIONS.YOUR_NOTIFICATIONS"
					id="title">
					{{ constants.NOTIFICATIONS.YOUR_NOTIFICATIONS }}
				</ea-heading>
			</div>
		</div>
		@if (isNotificationPageAvailable) {
			<ea-notifications></ea-notifications>
		}
	</ng-template>
</ea-slider>
